module.exports = __webpack_public_path__ + "img/softinya-prop-3.f4727a7a.webp";